module.exports = __webpack_public_path__ + "static/img/headImg.7043029e.svg";